import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from "vue";
import {sysNoticeApi} from "@/api/sysNotice";
import TextScroll from "text-scroll";
import Cookies from "js-cookie";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const datas = ref([] as any);
const texts = ref([]);

//更多弹框
const moreDialog = ref({
    visible: false,
});
//内容弹框
const noticeDialog = ref({
    visible: false,
    notice: {
        title: '',
        content: ''
    }
});

/**
 * 自动弹出的系统公告。
 */
const noticeAutoShowDialog = ref({
    visible: false,
    noticeList: [],
    currentIndex: 0
});

onMounted(() => {
    query(() => {
        if (datas.value.length > 0 && datas.value[0].title === '平台停机维护通知') {
            viewContent(datas.value[0]);
        }
        //有新通知自动弹出，将已读通知存入cookie
        if(datas.value.length>0){
            noticeAutoShowDialog.value.currentIndex = 0;
            const readedIdsStr = Cookies.get('notice-autoshow-readedIds') || '';
            const readedIds = readedIdsStr.split(',');
            if(readedIds && readedIds.length>0){
                const unReaded = datas.value.filter((item:any)=>!readedIds.includes(item.id+''));
                if(unReaded && unReaded.length>0){
                    noticeAutoShowDialog.value.noticeList = unReaded;
                }
            }else{
                noticeAutoShowDialog.value.noticeList = datas.value;
            }
            //过滤掉25年之前的
            noticeAutoShowDialog.value.noticeList = noticeAutoShowDialog.value.noticeList.filter((item:any)=>{
                const date = new Date(item.createTime);
                return date.getFullYear()>=2025;
            });
            if(noticeAutoShowDialog.value.noticeList && noticeAutoShowDialog.value.noticeList.length>0){
                noticeAutoShowDialog.value.visible = true;
            }
        }
    })
});

const query = (callback: any) => {
    sysNoticeApi.listPublishNotice().then((r: any) => {
        if(r.data.result === 0){
            const dataList = r.data.data;
            datas.value = dataList;
            const titles = dataList.map((data: any) => data.title);
            texts.value = titles;
            if(callback){
                callback();
            }
        }
    });
};

const moreNotice = () => {
    query(() => {
        moreDialog.value.visible = true;
    })
}

/**
 * 自动弹出提示框下一条事件
 */
const nextNoticeClick = () => {
    const readedIdsStr = Cookies.get('notice-autoshow-readedIds') || '';
    let readedIds = readedIdsStr.split(',');
    readedIds.push(noticeAutoShowDialog.value.noticeList[noticeAutoShowDialog.value.currentIndex].id);
    Cookies.set('notice-autoshow-readedIds', readedIds.join(','));
    if(noticeAutoShowDialog.value.currentIndex<(noticeAutoShowDialog.value.noticeList.length-1)){
        noticeAutoShowDialog.value.currentIndex++;
    }else{
        noticeAutoShowDialog.value.visible = false;
    }
};

const viewContent = (notice: any) => {
    noticeDialog.value.notice = notice;
    noticeDialog.value.visible = true;
}

return { __sfc: true,datas, texts, moreDialog, noticeDialog, noticeAutoShowDialog, query, moreNotice, nextNoticeClick, viewContent, TextScroll }
}

})